export const theme = {
  colors: {
    primaryBlue: "#1D74D2",
    secondaryBlue: "#9ABCEB",
    contrastOrange: "#F7931E",
    paleOrange: "#FBB040",
    background: "#F5F7F9",
    text: "#014B99",
    white: "#FFFFFF",
    snowWhite: "#F8F8F8",
  },
}

export type ThemeType = typeof theme
